module.exports = __webpack_public_path__ + "img/menu_device_icon.c0ca68bf.svg";